export default __webpack_public_path__ + "static/media/PFM_LinearGraphic.a54add62.png";